import { useState } from 'react';
import { classReuseService } from '../services/classReuseService';
import { ClassReuseDraft, ImportedTrimesterPreview, ReusableClass } from '../types/trimestersSettings.types';

export const useClassReuse = () => {
  const [draft, setDraft] = useState<ClassReuseDraft | null>(null);
  const [importPreview, setImportPreview] = useState<ImportedTrimesterPreview | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const startDraft = async (sourceTrimesterId: string, targetTrimesterId: string) => {
    setIsLoading(true);
    const nextDraft = await classReuseService.buildDraft(sourceTrimesterId, targetTrimesterId);
    setDraft(nextDraft);
    setIsLoading(false);
  };

  const updateClass = (classId: string, updates: Partial<ReusableClass>) => {
    setDraft((current) => {
      if (!current) return current;

      return {
        ...current,
        classes: current.classes.map((classItem) =>
          classItem.id === classId ? { ...classItem, ...updates } : classItem
        ),
      };
    });
  };

  const finishDraft = async () => {
    if (!draft) return null;
    const saved = await classReuseService.saveDraft(draft);
    setDraft(null);
    return saved;
  };

  const importTrimester = async (file: File) => {
    setIsLoading(true);
    const preview = await classReuseService.importTrimesterFile(file);
    setImportPreview(preview);
    setIsLoading(false);
  };

  const clearImportPreview = () => setImportPreview(null);
  const clearDraft = () => setDraft(null);

  return {
    draft,
    importPreview,
    isLoading,
    startDraft,
    updateClass,
    finishDraft,
    importTrimester,
    clearImportPreview,
    clearDraft,
  };
};
